export type UserGroup = Readonly<{
    id: number
    name: string
    isActive: boolean
    domains: string[]
}>
export type Domain = Readonly<{
    id: number
    domain: string
}>

export interface ConfirmedDomain extends Domain {
    isConfirmed: boolean
}

export type HistoryType = Readonly<{
    created: HistoryDetailsType
    updated?: HistoryDetailsType
}>
export type HistoryDetailsType = Readonly<{
    timestamp: string
    author: string
}>
export type CreateUpdateUserGroup = Readonly<{
    name: string
    domains: { id: number }[]
    billReceivers: { id: number }[]
    isActive: boolean
}>

export type CreateUpdateUserGroupFormValues = Readonly<{
    name: string
    domains: ConfirmedDomain[]
    billReceivers: BillReceiver[]
    isActive: boolean
}>

export enum BillReceiverType {
    EAN_NUMBER = "EAN_NUMBER",
    EMAIL_ADDRESS = "EMAIL_ADDRESS",
}

interface BaseBillReceiver {
    id: number
    name: string
    displayAddress: string
}

interface EanBillReceiver extends BaseBillReceiver {
    endpoint: {
        type: BillReceiverType.EAN_NUMBER
        eanNumber: string
    }
}

interface EmailBillReceiver extends BaseBillReceiver {
    endpoint: {
        type: BillReceiverType.EMAIL_ADDRESS
        email: string
    }
}

type BillReceiver = EanBillReceiver | EmailBillReceiver

export type UserGroupDetails = Readonly<{
    id: number
    company: {
        id: number
        name: string
    }
    name: string
    domains: ConfirmedDomain[]
    billReceivers: BillReceiver[]
    isActive: boolean
    history?: HistoryType
}>

// DOMAINS
export type CreateUpdateDomain = Readonly<{
    username: string
    domain?: string
}>

export type CreateUpdateDomainFormValues = Readonly<{
    username: string
    domain: string
}>

export type DomainDetails = Readonly<{
    id: number
    userGroup: {
        id: number
        name: string
    }
    domain: string
    username: string
    isConfirmed: boolean
}>
